module.exports = __webpack_public_path__ + "static/michael-mccalla-team-cycling-e19107e12b96f416f1b92d3c42908ac0.webp";